var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91453 13.0657C15.0688 13.0657 17.8473 10.3639 17.8473 6.49821C17.8473 2.63251 15.5354 0 10.3812 0C6.15676 0 3.84171 2.1709 1.08868 4.7525C0.947703 4.88471 0.805574 5.01798 0.661981 5.1521C-0.14524 5.90607 -0.233001 7.17733 0.502425 8.00148C3.14806 10.9663 5.47864 13.0657 9.91453 13.0657ZM3.74182 6.68091C4.25928 6.01863 5.22547 5.34956 6.40293 4.84309C7.57019 4.341 8.84699 4.04122 9.91533 4.04122C11.6918 4.04122 12.8084 4.49738 13.3916 4.73563C13.4953 4.77802 13.5821 4.8135 13.6528 4.8383C14.0698 4.98454 14.5263 4.7651 14.6725 4.34818C14.8188 3.93125 14.5993 3.47472 14.1824 3.32848C14.1401 3.31364 14.0789 3.2882 13.9992 3.25509L13.9992 3.25508C13.4532 3.02815 12.0408 2.44122 9.91533 2.44122C8.58229 2.44122 7.08908 2.8062 5.77071 3.37329C4.46253 3.93599 3.22745 4.74049 2.48103 5.69582C2.209 6.04397 2.27072 6.54673 2.61888 6.81876C2.96704 7.09079 3.46979 7.02907 3.74182 6.68091Z",
    fill: "#1EB65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/level-1.45b8f7632e3317cf5dc05d954b0b3b41.svg";
export { ForwardRef as ReactComponent };